import Filter from "SandboxViewerComponent/src/widgets/Filter/Filter";

/**
 * Custom Filter extension that adds hideAsDropdown functionality
 * without modifying the SandboxViewerComponent code
 */
class CustomFilter extends Filter {
  /**
   * Override getVisibilityDependencies to support hideAsDropdown
   */
  getVisibilityDependencies(level) {
    return level.slice(1).map((l, i) => {
      return {
        triggerCondition: {
          and: level
            .slice(0, i + 1)
            .map((sl) => {
              return {
                or: [
                  {
                    atom: {
                      attribute: sl,
                      filled: true,
                    },
                  },
                  {
                    atom: {
                      attribute: sl,
                      customFunction: this.isSkipped.bind(this),
                    },
                  },
                ],
              };
            })
            .concat([
              {
                not: {
                  or: [
                    {
                      atom: {
                        attribute: l,
                        customFunction: this.isSkipped.bind(this),
                      },
                    },
                    {
                      atom: {
                        attribute: l,
                        customFunction: this.isHiddenAsDropdown.bind(this),
                      },
                    },
                  ],
                },
              },
            ]),
        },
        effects: [
          {
            display: [l],
          },
        ],
      };
    });
  }

  /**
   * Check if attribute should be hidden as dropdown
   */
  isHiddenAsDropdown(value, attributeStore, attributeId) {
    const { hideAsDropdown = [] } = this.props;
    return hideAsDropdown.indexOf(attributeId) !== -1;
  }

  /**
   * Override getTreeAttributes to inject a data-cy attribute per filter level.
   * This gives Cypress stable, semantic selectors (e.g. [data-cy="filter-kategorie"])
   * without coupling tests to MUI internals or generated class names.
   */
  getTreeAttributes(theme) {
    return super.getTreeAttributes(theme).map((attr) => ({
      // Enable typed search for all Filter dropDown levels rendered by AttributeEdit.
      ...attr,
      attributeOption: {
        ...attr.attributeOption,
        filterable: true,
        noOptionsText: "Keine Treffer gefunden",
        inputProps: { "data-cy": `filter-${attr.id.toLowerCase()}` },
      },
    }));
  }
}

export default CustomFilter;
